import styled from "styled-components"
import { Link } from "react-router-dom"

export default function ExpiredForm({ visible }) {
	return visible === true ? (
		<FormWrapper>
			<TxtWrapper>
				<TopTxt>모티벨 퀴즈가 마감 되었어요</TopTxt>
				<TopTxt>다른 퀴즈에 참여해보세요!</TopTxt>
			</TxtWrapper>
			<ListBtn to={"/?list=motibell"}>다른 퀴즈 둘러보기</ListBtn>
		</FormWrapper>
	) : null
}
const FormWrapper = styled.form`
	background: #7f7f7f;
	border: 4px solid #fff0bd;
	border-radius: calc(100vw * (14 / 375));
	padding: calc(100vw * (42 / 375)) calc(100vw * (16 / 375)) calc(100vw * (30 / 375));
`
const TxtWrapper = styled.div`
	margin-bottom: calc(100vw * (28 / 375));
`
const TopTxt = styled.div`
	font-weight: 700;
	font-size: calc(100vw * (20 / 375));
	line-height: 155.49%;
	text-align: center;
	color: #efefef;
`

const ListBtn = styled(Link)`
	display: flex;
	align-items: center;
	justify-content: center;
	height: calc(100vw * (57 / 375));
	width: 100%;
	background: #ffffff;
	border: 1px solid #c6c6c6;
	border-radius: calc(100vw * (10 / 375));

	font-style: normal;
	font-weight: 600;
	font-size: calc(100vw * (18 / 375));
	line-height: 202.99%;
	color: #000000;
`
